import { CreateUserRequestDto } from '@repo/services/hooks';
import { makeSearchParams } from '@repo/utils';
import axios from 'axios';

import http from 'services/http';
import { CreateUserResponseDto } from 'utils/auth';

type PasswordForgotRequestDto = {
  username: string;
  email: string;
};

export const postPasswordForgot = async ({ username, email }: PasswordForgotRequestDto) =>
  await http.post('/password/forgot', { username, email }, { useToken: false, useErrorToast: false });

export const postRegisterUser = async (createUserRequestDto: CreateUserRequestDto) => {
  return await http.post<CreateUserResponseDto>('/users', createUserRequestDto, { useToken: false });
};

/**
 * 카카오는 외부 오리진이라 **공용 http 인스턴스로 보내면 안 된다**. 인터셉터와 로그인 시 심는
 * defaults 가 X-Bubbletap-Platform/Version/Store 를 붙이는데, 카카오 프리플라이트 응답의
 * Access-Control-Allow-Headers 에 이 3종이 없어 브라우저가 요청 자체를 막는다(#2426).
 */
export const postKakaoToken = async (encodedOrigin: string, code: string) => {
  const { data } = await axios.post<any>(
    'https://kauth.kakao.com/oauth/token',
    makeSearchParams({
      grant_type: 'authorization_code',
      client_id: import.meta.env.VITE_APP_KAKAO_KEY,
      redirectUri: encodedOrigin,
      code,
      client_secret: import.meta.env.VITE_APP_KAKAO_SECRET,
    })
  );

  return data;
};

type KakaoLoginRequestDto = {
  token: string;
};
export const postKakaoLogin = async (kakaoToken: string) =>
  http.post<KakaoLoginRequestDto>('/auth/kakao', { accessToken: kakaoToken });

// export const postKakaoLogin = async (kakaoToken: string) =>
// axiosInstance.post('/auth/kakao', { accessToken: kakaoToken });

export interface CustomTokenDto {
  token: string;
}
type BubbletapLoginRequestDto = {
  username: string;
  password: string;
};
export const postBubbletapLogin = async ({ username, password }: BubbletapLoginRequestDto) =>
  await http.post<CustomTokenDto>('/auth/password', { username, password }, { useToken: false, useErrorToast: false });
